import request from '@/utils/request'

const fapiaoApi = {
  trade_fapiao_list: '/trade/fapiao/',
  trade_fapiao_create: '/trade/fapiao/',
  trade_fapiao_update: '/trade/fapiao/',
  trade_fapiao_delete: '/trade/fapiao/',
  trade_fapiao_archived: '/trade/fapiao_archived/',
  trade_fapiao_to_jd: '/trade/fapiao_to_jd/',
  trade_fapiao_information_list: '/trade/fapiao_information/',
  trade_fapiao_information_create: '/trade/fapiao_information/',
  trade_fapiao_information_update: '/trade/fapiao_information/',
  trade_fapiao_information_delete: '/trade/fapiao_information/'
}

/**
 * 列表
 */
export function fapiao_list (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function fapiao_create (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function fapiao_update (parameter, fapiao_id) {
  return request({
    url: fapiaoApi.trade_fapiao_update + fapiao_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function fapiao_delete (fapiao_id) {
  return request({
    url: fapiaoApi.trade_fapiao_delete + fapiao_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function fapiao_archived (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function fapiao_to_jd (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_to_jd,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
    data: parameter
  })
}

/**
 * 列表
 */
export function fapiao_information_list (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_information_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function fapiao_information_create (parameter) {
  return request({
    url: fapiaoApi.trade_fapiao_information_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function fapiao_information_update (parameter, corporation_id) {
  return request({
    url: fapiaoApi.trade_fapiao_information_update + corporation_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function fapiao_information_delete (corporation_id) {
  return request({
    url: fapiaoApi.trade_fapiao_information_delete + corporation_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
